if (!customElements.get('video-banner')) {
  customElements.define(
    'video-banner',
    class VideoBanner extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'complete') {
          this.loadVisibleVideo();
        } else {
          window.addEventListener('load', () => this.loadVisibleVideo(), { once: true });
        }

        // If the viewport crosses the mobile/desktop breakpoint, load the other video too.
        this.breakpoint = window.matchMedia('(min-width: 750px)');
        this.breakpoint.addEventListener('change', () => this.loadVisibleVideo());
      }

      loadVisibleVideo() {
        this.querySelectorAll('video').forEach((video) => {
          // Skip videos hidden by CSS for the current device (small-hide / small-up-hide).
          if (video.offsetParent === null && video.offsetWidth === 0 && video.offsetHeight === 0) return;
          if (video.dataset.loaded) return;
          video.dataset.loaded = 'true';
          video.preload = 'auto';
          video.muted = true;
          video.setAttribute('playsinline', '');
          const playPromise = video.play();
          if (playPromise) playPromise.catch(() => {});
        });
      }
    }
  )
}
